import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Handle chunk load errors (happens after deployments when old JS tries to load new chunks)
window.addEventListener('error', (event) => {
  // Check if it's a chunk load error
  if (
    event.message.includes('Failed to fetch dynamically imported module') ||
    event.message.includes('Importing a module script failed') ||
    (event.target as HTMLScriptElement)?.src?.includes('.js')
  ) {
    console.warn('Chunk load error detected, reloading page...');
    // Prevent infinite reload loops by checking if we just reloaded
    const hasReloaded = sessionStorage.getItem('chunk-error-reload');
    if (!hasReloaded) {
      sessionStorage.setItem('chunk-error-reload', 'true');
      window.location.reload();
    } else {
      // Clear the flag after successful load
      sessionStorage.removeItem('chunk-error-reload');
    }
  }
});

// Clear reload flag on successful load
window.addEventListener('load', () => {
  sessionStorage.removeItem('chunk-error-reload');
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
